import { techDocs } from "../technical-docs";

export default techDocs('certificates', 'Certificados & Laudos', 'documentos-tecnicos-certificados-laudos')